import React, { useState,  useMemo } from 'react';
import axios from 'axios';
import {setConfig} from '../helpers/config'

const EnvironmentContext = React.createContext({
	loadEnvironment: async () => {},
});

export const EnvironmentContextProvider = ({ children }) => {
	const [environment, setEnvironment] = useState(null);

	const loadEnvironment = async() => {
		console.log("loadEnv")
		console.log(process.env.PUBLIC_URL + '/config/appConfig.json');
		const response = await axios.get(process.env.PUBLIC_URL + '/config/appConfig.json');
		setEnvironment(response.data);
		setConfig(response.data);
		return environment;
	}

	const contextValue = useMemo(() => ({
		loadEnvironment: loadEnvironment,
		environment: environment
	}), [environment]);

	return (
		<EnvironmentContext.Provider value={contextValue}>
			{ children }
		</EnvironmentContext.Provider>
	);
};

export default EnvironmentContext;
